// extracted by mini-css-extract-plugin
export default {"invalidDataError":"ProductDetail_invalidDataError__vNUGF"};